module.exports = __webpack_public_path__ + "media/images/logo-63fe75fa1df749205b66cdf578671e6b.svg";